import {Strings} from 'Strings';

export class Utils {
    static scopedEvent(eventName: string | string[],
                       scope: ng.IScope,
                       func: EventListenerOrEventListenerObject,
                       element: EventTarget = window,
                       useCapture = false): Function {
        const events: Array<string> = Array.isArray(eventName) ? eventName : [eventName];
        const destroy               = events.map(name => {
            element.addEventListener(name, func, useCapture);
            scope.$on('$destroy', () => element.removeEventListener(name, func));
            return () => element.removeEventListener(name, func);
        });
        return () => destroy.forEach(f => f());
    };

    static getBrowserName() {
        const browsers = ['Opera', 'Chrome', 'Safari', 'Firefox', 'MSIE', 'unknown'];
        const index = browsers.findIndex((browser => navigator.userAgent.includes(browser)));
        return browsers[index];
    }

    static oneTimeEvent(eventName: string | string[],
                        scope: ng.IScope,
                        func: EventListenerOrEventListenerObject,
                        element: EventTarget = window): Function {
        let destroy: Function | null = null;
        const oneTime                = _.once((...args: any[]) => {
            (func as any)(...args);
            destroy && destroy();
        });
        destroy                      = Utils.scopedEvent(eventName, scope, oneTime, element);
        return destroy;
    }

    static isApiError(a: any, code?: number, msg?: RegExp): a is ApiError {
        return !!a.errorCode &&
            (!code || a.errorCode === code) &&
            (!msg || msg.test(a.errorMessage));
    }

    static getProduct(url = window.location.pathname, stateName?: string) {
        let currentProduct                          = '' as AnimatronProduct;
        const animatronProducts: AnimatronProduct[] = ['WAVE', 'STUDIO'];

        animatronProducts.some(product => {
            const productL  = product.toLowerCase();
            const isProduct = url.startsWith(`/${productL}/`) ||
                (stateName && stateName.startsWith(`${productL}-`));

            currentProduct = isProduct ? product : 'ANY';

            return isProduct;
        });

        return currentProduct;
    }

    static getProductByState(state: ng.ui.IStateService) {
        const {url, name} = state.current;
        return Utils.getProduct(url as string, name);
    }

    static isUser(a: any): a is anm.User {
        return a.username && a.displayName;
    }

    static redirect(url: string,
                    location: ng.ILocationService,
                    shouldReplace?: boolean) {
        if (!url) {
            throw new Error('Empty url was passed to redirect');
        }

        const [path, hash]       = url.split('#');
        const [state, paramsStr] = path.split('?');
        const newLoc             = location
            .url(state)
            .search(Strings.toParams(paramsStr));

        if (hash) {
            newLoc.hash(hash).replace();
        }

        if (!hash && shouldReplace) {
            newLoc.replace();
        }
    }

    static isSecureUser = (a: any): a is anm.SecureUser => a.encryptedToken && a.userProfile;

    static sequence = (array: Array<string>, $ocLazyLoad: oc.ILazyLoad): Promise<any> =>
        array.reduce((acc, val) => acc.then(() => $ocLazyLoad.load(val)), Promise.resolve());

    static toParams = (obj: any) => Object.keys(obj).map(k => `${k}=${obj[k]}`).join('&');

    static matchesSelector = (element: HTMLElement, selector: string) => {
        const ElementPrototype = Element.prototype;
        const fn               = ElementPrototype.matches ||
            ElementPrototype.webkitMatchesSelector ||
            ElementPrototype.msMatchesSelector;
        return fn.call(element, selector);
    };

    static rAF = (function () {
        let lastTime  = 0;
        const vendors = ['ms', 'moz', 'webkit', 'o'];
        for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
            window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
            window.cancelAnimationFrame  = window[vendors[x] + 'CancelAnimationFrame']
                || window[vendors[x] + 'CancelRequestAnimationFrame'];
        }

        if (!window.requestAnimationFrame)
            window.requestAnimationFrame = (callback: FrameRequestCallback) => {
                const currTime   = new Date().getTime();
                const timeToCall = Math.max(0, 16 - (currTime - lastTime));
                const id         = window.setTimeout(() => callback(currTime + timeToCall), timeToCall);
                lastTime         = currTime + timeToCall;
                return id;
            };

        if (!window.cancelAnimationFrame) window.cancelAnimationFrame = id => clearTimeout(id);
        return window.requestAnimationFrame.bind(window);
    }());
    // _.filterObj = (obj: any, pred: any) => _.object(Object.keys(obj).filter(k => pred(k, obj[k])).map(k => [k, obj[k]]));

    public static safe<T>(f: () => T) {
        try { f() } catch (e) {}
    }

    public static waitFor(check: () => void, cb: () => void) {
        if (check()) {
            cb();
        } else {
            setTimeout(() => Utils.waitFor(check, cb), 100);
        }
    }
}
_.mixin(Utils);




// WEBPACK FOOTER //
// ./app/assets/javascripts/underscore-extensions.ts